import { render, staticRenderFns } from "./ProducerReview.vue?vue&type=template&id=586f3be6&"
import script from "./ProducerReview.vue?vue&type=script&lang=js&"
export * from "./ProducerReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports